import { useDispatch, useSelector } from "react-redux";
import { toggleFilter } from "../../redux/features/filter/filterSlice";
import { useGetProjectsQuery } from "../../redux/features/projects/projectsApi";


export default function ProjectList(){

    const dispatch = useDispatch()
    const {data: projects, isLoading, isError} = useGetProjectsQuery();
    const {filter} = useSelector(state=>state.filter) || {}

    const filterHandler =(item)=>{
        dispatch(toggleFilter(item))
    }

    // decide what to render
    let content = null;
    if(isLoading){content=  <div>Loading....</div>}
    else if(!isLoading && isError){content=  <div>There was an error occurred</div> }
    else if(!isLoading && !isError && projects?.length <= 0){content=  <div>Team not found</div> }
    else if(!isLoading && !isError && projects?.length > 0){
       
        content=  projects.map(item=>{
        const {projectName, colorClass, id} = item || {};
        const isChecked = !!filter.find(item=> item.id === id)

      return <div key={id} className="checkbox-container">
      <input type="checkbox" className={colorClass} checked={isChecked} onChange={()=>filterHandler(item)} />
      <p className="label">{projectName}</p>
    </div>})

    }

  return(
    <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">
          {content}
        </div>
      </div>
  )};